module.exports = __webpack_public_path__ + "static/img/ebay.6d08a0cf.png";